export function storeCredential(credential) {
    window?.google?.accounts?.id?.storeCredential(credential);
}

export function googleLogout() {
    window?.google?.accounts?.id?.disableAutoSelect();
}

export function extractClientId(credentialResponse) {
    const clientId = credentialResponse?.clientId ?? credentialResponse?.client_id;
    return clientId;
}
